export default __webpack_public_path__ + "1391fd7508f3172f6de83d258a95eaac.svg";